import { ChangeEvent, useEffect, useState } from 'react';

import { CurrentCarPlaceInfoType } from '../../feature/type/CurrentCarPlaceInfoType';

type InputType = {
	currentCarPlaceInfoList: CurrentCarPlaceInfoType[] | [];
	setCenteredCurrentCarPlaceInfo: (value: CurrentCarPlaceInfoType) => void;
};

/**
 * テーブルページの状態管理用カスタムフック
 */
export const useStateTablePage = (input: InputType) => {
	const { currentCarPlaceInfoList, setCenteredCurrentCarPlaceInfo } = input;

	const [page, setPage] = useState(0); // ページインデックスの管理
	const [rowsPerPage, setRowsPerPage] = useState(10); // ページごとの行数の管理

	const [selectedRowIdx, setSelectedRowIdx] = useState(0); // 選択された検索結果のインデックスを管理
	const [selectedRowCarCode, setSelectedCarCode] = useState(''); // 選択された検索結果の車両コードを管理

	useEffect(() => {
		setPage(0);
		setSelectedRowIdx(0);

		const carCode = currentCarPlaceInfoList.length ? currentCarPlaceInfoList[0].carCode : '';
		setSelectedCarCode(carCode);
	}, [currentCarPlaceInfoList]);

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleTableRowClick = (row: CurrentCarPlaceInfoType, index: number) => {
		if (row.lat !== 0 && row.lon !== 0) {
			setCenteredCurrentCarPlaceInfo(row);
		}
		setSelectedRowIdx(index);
		setSelectedCarCode(row.carCode);
	};

	const isRowSelected = (index: number, carCode: string) => selectedRowIdx === index && selectedRowCarCode === carCode;

	return {
		page,
		rowsPerPage,
		handleChangePage,
		handleChangeRowsPerPage,
		handleTableRowClick,
		isRowSelected,
	};
};
